import { CSSProperties, ChangeEvent, ReactElement, useState } from 'react';
import { ReactComponent as CheckSelected } from '@assets/images/check-black.svg';
import { ReactComponent as CheckUnSelected } from '@assets/images/check-gray.svg';
import './Radio.scss';

export interface RadioProps {
  label?: string;
  value?: string;
  name?: string;
  checked?: boolean;
  checkedIcon?: ReactElement;
  defaultIcon?: ReactElement;
  disabled?: boolean;
  style?: CSSProperties;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}
interface RadioGroupProps {
  keyName: string;
  options: Pick<RadioProps, 'label' | 'value' | 'disabled' | 'style'>[];
  defaultChecked?: string;
  checkedIcon?: ReactElement;
  defaultIcon?: ReactElement;
  style?: CSSProperties;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Radio: React.FC<RadioProps> & { Group: React.FC<RadioGroupProps> } = (props) => {
  const { name, label, value, checked, checkedIcon, defaultIcon, disabled, style, onChange } = props;

  const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  return (
    <label className={`radio ${!disabled ? '' : 'radio--disabled'}`} style={style}>
      {checked ? checkedIcon || <CheckSelected /> : defaultIcon || <CheckUnSelected />}
      <input
        className="radio__item"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChecked}
        disabled={disabled}
      />
      {label && <span>{label}</span>}
    </label>
  );
};

const Group: React.FC<RadioGroupProps> = (props) => {
  const { keyName, options, defaultChecked, onChange, checkedIcon, defaultIcon, style } = props;
  const [checked, setChecked] = useState(defaultChecked || '');

  const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
    setChecked(e.target.value);
  };

  return (
    <fieldset className="group-radio" style={style}>
      {options.map(({ label, value, disabled, style: optionStyle }) => (
        <Radio
          key={value}
          name={keyName}
          label={label}
          value={value}
          checked={checked === value}
          disabled={disabled}
          style={optionStyle}
          onChange={handleChecked}
          checkedIcon={checkedIcon}
          defaultIcon={defaultIcon}
        />
      ))}
    </fieldset>
  );
};

Radio.Group = Group;

export default Radio;
